import { getUser } from "../auth/Auth";
import API from "./API";
//import Storage from "./Storage";

var language = null;

export default class Translation {

    constructor() {
        this.api = new API({
            "get_translations": "/translation/fetch/all"
        });
    }

    loadFromServer(notify_parent) {
        this.api.request({
            route: "get_translations",
            success: (translations) => {
                //Storage.set("translations", translations);

                let indexedTranslations = [];

                translations.forEach((trans, index) => {

                    if (!indexedTranslations[trans.language]) {
                        indexedTranslations[trans.language] = [];
                    }

                    if (!indexedTranslations[trans.language][trans.original.charAt(0)]) {
                        indexedTranslations[trans.language][trans.original.charAt(0)] = [];
                    }

                    indexedTranslations[trans.language][trans.original.charAt(0)].push(trans);
                });


                window.translator.translations = indexedTranslations;

               // console.log(window.translator.translations);


                notify_parent();
            }
        });

    }

}


export const translate = function (original) {

    let translations = window.translator.translations;

    if (!translations) {
        return original;
    }

    if (language === null) {
        language = getUser().language;
    }

   // var t0 = performance.now();

    if(!translations[language]) {
        return original;
    }

    if(!translations[language][original.charAt(0)]){
        return original;
    }

    const translation = translations[language][original.charAt(0)].find((t) => {
        return t.original === original && t.language === language;
    });

    // console.log("Translation found in " + (performance.now() - t0) + " milliseconds.");

    if (!translation) {
        return original;
    }

    return translation.translated;
}

export const languages = [
    { key: "sk", value: "Slovenčina" },
    { key: "en", value: "English" },
    { key: "de", value: "German" }
]


// WEBPACK FOOTER //
// ./src/modules/base/Translation.js